import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@material-ui/core';
import { jsx as _jsx } from "react/jsx-runtime";
const TooltipButton = _ref => {
  let {
    children,
    color,
    disabled,
    tooltipMessage,
    onClick,
    size,
    style
  } = _ref;
  const showTooltip = Boolean(tooltipMessage);
  const disablePointerEventsStyle = {
    pointerEvents: disabled ? 'none' : 'auto'
  };
  const mergedStyle = style && typeof style === 'object' ? {
    ...disablePointerEventsStyle,
    ...style
  } : disablePointerEventsStyle;
  const button = /*#__PURE__*/_jsx("button", {
    type: "button",
    className: `inline-container ${size} ${color}`,
    disabled: disabled,
    onClick: onClick,
    style: mergedStyle,
    children: children
  });
  if (showTooltip) {
    return /*#__PURE__*/_jsx(Tooltip, {
      title: tooltipMessage,
      children: /*#__PURE__*/_jsx("span", {
        children: button
      })
    });
  }
  return button;
};
TooltipButton.defaultProps = {
  size: 'large',
  color: 'secondary',
  disabled: false
};
TooltipButton.propTypes = {
  children: PropTypes.oneOfType([PropTypes.element, PropTypes.node, PropTypes.arrayOf(PropTypes.node)]).isRequired,
  size: PropTypes.string,
  color: PropTypes.string,
  style: PropTypes.object,
  disabled: PropTypes.bool,
  tooltipMessage: PropTypes.oneOfType([PropTypes.element, PropTypes.node]),
  onClick: PropTypes.func.isRequired
};
export default TooltipButton;